(function () {
  var badgeSelector = ".product-label--on-sale.js-sale-badge";


  function moneyFormat() {
    return (window.theme && theme.moneyFormat) ? theme.moneyFormat : "{{amount}}€";
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat());
    }
    return (cents / 100).toFixed(2) + "€";
  }

  function getVariantId() {
       var id = parseInt(input.value, 10);
    return Number.isFinite(id) ? id : null;
  }

  function getProductJson() {
  var el = document.getElementById("custom-product-json");
  if (!el) return null;

  try {
    var data = JSON.parse(el.textContent);
    if (data && Array.isArray(data.variants)) return data;
  } catch (e) {}

  return null;
}


  function computeLabel(variant) {
  if (!variant) return null;

  var price = Number(variant.price);
  var compare = Number(variant.compare_at_price);

  if (!compare || !price || compare <= price) return null;

  var savings = compare - price;
  var percent = Math.round((savings * 100) / compare);

  return "-" + percent + "% (" + formatMoney(savings) + ")";
}


  function apply() {
    var badge = document.querySelector(badgeSelector);
    if (!badge) return;

    var product = getProductJson();
    var id = getVariantId();
    if (!product || !id) return;

    var variant = product.variants.find(function (v) { return v.id === id; });
    var label = computeLabel(variant);

    if (!label) {
      badge.style.display = "none";
      return;
    }

    // Guardamos o texto “oficial” e impomos sempre
    badge.dataset.discountText = label;
    badge.textContent = label;
    badge.style.display = "";
  }

  function lockAgainstThemeOverwrite() {
    var badge = document.querySelector(badgeSelector);
    if (!badge) return;

    var obs = new MutationObserver(function () {
      if (badge.dataset.discountText && badge.textContent !== badge.dataset.discountText) {
        badge.textContent = badge.dataset.discountText;
      }
    });

    obs.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    lockAgainstThemeOverwrite();

    // Warehouse às vezes escreve depois do load, então reaplicamos
    apply();
    setTimeout(apply, 150);
    setTimeout(apply, 500);
    setTimeout(apply, 1000);

    // Apanha mudanças silenciosas do input id (troca de variante)
    var last = null;
    setInterval(function () {
      var id = getVariantId();
      if (id && id !== last) {
        last = id;
        apply();
      }
    }, 350);
  }

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("load", boot);

  // Eventos comuns (se o tema os emitir)
  document.addEventListener("variant:changed", apply);
  document.addEventListener("variant:change", apply);
  document.addEventListener("product:variant-change", apply);
})();


